<template>
  <div class="planogram-page">
    <Planogram />
  </div>
</template>

<script>
import Planogram from '../../components/planogram/Planogram.vue'

export default {
  name: 'PlanogramPage',
  components: {
    Planogram
  },
  metaInfo: {
    title: 'Visual Merchandising - Planogramma'
  }
}
</script>

<style scoped>
.planogram-page {
  height: 100vh;
  overflow: hidden;
}
</style>